import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@commenda/kakashi';
import { TWorkflowDefinition } from '@commenda/types';
import { useState } from 'react';
import { useNotification } from '../../../hooks/useNotification';

type TImportFromJsonModalProps = {
  isOpen: boolean;
  onClose: () => void;
  setWorkflowDefinition: (definition: TWorkflowDefinition) => void;
};

export const ImportFromJsonModal = ({
  isOpen,
  onClose,
  setWorkflowDefinition,
}: TImportFromJsonModalProps) => {
  const { setNotification } = useNotification();
  const [workflowDefinitionJson, setWorkflowDefinitionJson] =
    useState<string>('');

  const onImport = () => {
    try {
      const definition = JSON.parse(workflowDefinitionJson);
      setWorkflowDefinition(definition);
      onClose();
      setNotification({
        title: 'Success',
        message: 'Workflow definition imported successfully',
        show: true,
        valid: true,
      });
    } catch (error) {
      console.error(error);
      setNotification({
        title: 'Error',
        message: 'Failed to import workflow definition',
        show: true,
        valid: false,
      });
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Import From JSON</DialogTitle>
        </DialogHeader>
        <div className="p-6">
          <Textarea
            placeholder="Paste your JSON here"
            value={workflowDefinitionJson}
            onChange={(e) => setWorkflowDefinitionJson(e.target.value)}
          />
        </div>
        <DialogFooter>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onImport}>Import</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
